"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementNode = void 0;
var react_1 = __importDefault(require("react"));
var react_flow_renderer_1 = require("react-flow-renderer");
require("./styles/element-node.scss");
var HOVER_COLOR = '#FF5800';
var HOVER_BACKGROUND = '#FFF4EC';
var METRIC_PATH_COLOR = '#47800A';
var METRIC_PATH_BACKGROUND = '#EEF6E6';
/**
 * ElementNode - Custom node component for strategy elements
 * Displays element name with configurable connection handles
 */
exports.ElementNode = function (_a) {
    var data = _a.data, id = _a.id;
    var handleMouseEnter = function () {
        if (data.onNodeHover) {
            data.onNodeHover(id);
        }
    };
    var handleMouseLeave = function () {
        if (data.onNodeHover) {
            data.onNodeHover(null);
        }
    };
    var getBorderColor = function () {
        if (data.isHovered || data.isConnected) {
            return HOVER_COLOR;
        }
        if (data.isMetricPath) {
            return METRIC_PATH_COLOR;
        }
        if (data.isAffected) {
            return HOVER_COLOR;
        }
        return data.color;
    };
    var borderColor = getBorderColor();
    var backgroundColor = borderColor === METRIC_PATH_COLOR
        ? METRIC_PATH_BACKGROUND
        : borderColor === HOVER_COLOR
            ? HOVER_BACKGROUND
            : undefined;
    return (react_1.default.createElement("div", { className: "strategy-element-node" + (data.isAffected ? ' strategy-element-node--affected' : ''), onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, style: __assign({ borderColor: borderColor }, (backgroundColor ? { backgroundColor: backgroundColor } : {})) },
        data.showLeftHandle && (react_1.default.createElement(react_flow_renderer_1.Handle, { type: "target", position: react_flow_renderer_1.Position.Left, id: "left", className: "element-handle", style: { backgroundColor: data.color, pointerEvents: 'none' } })),
        react_1.default.createElement("div", { className: "element-content" },
            react_1.default.createElement("div", { className: "element-label" }, data.label),
            data.isAffected && typeof data.score === 'number' && (react_1.default.createElement("div", { className: "element-score" }, data.score))),
        data.showRightHandle && (react_1.default.createElement(react_flow_renderer_1.Handle, { type: "source", position: react_flow_renderer_1.Position.Right, id: "right", className: "element-handle", style: { backgroundColor: data.color, pointerEvents: 'none' } }))));
};
